import React from "react";

const MobileCategoriesGrid = ({
  categories,
  shopAllLink = "/shop/collection?category_id=1563",
}) => {
  // Divide all categories into two rows
  const allCategories = categories || [];
  const totalCategories = allCategories.length;
  const firstRowCount = Math.ceil(totalCategories / 2);
  const secondRowCount = totalCategories - firstRowCount;

  const firstRowCategories = allCategories.slice(0, firstRowCount);
  const secondRowCategories = allCategories.slice(firstRowCount);

  return (
    <>
      <style>
        {`
          /* Hide on desktop, show only on mobile */
          .mobile-categories-grid-wrapper {
            display: none;
          }

          @media (max-width: 767px) {
            .mobile-categories-grid-wrapper {
              display: block;
            }
          }

          .mobile-categories-grid {
            padding: 12px 0;
            background-color: #fff;
            position: relative;
          }

          .mobile-categories-grid-inner {
            padding: 0 16px;
          }

          .mobile-categories-title {
            font-size: 20px;
            font-weight: 700;
            color: #333;
            text-align: center;
            margin-bottom: 12px;
            margin-top: 0;
            padding: 0 16px;
          }

          .mobile-categories-grid::before,
          .mobile-categories-grid::after {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            width: 100%;
            height: 16px;
            background-color: #FAFAFA;
          }

          .mobile-categories-grid::before {
            top: 0;
          }

          .mobile-categories-grid::after {
            bottom: 0;
          }

          .mobile-categories-scroll-container {
            overflow-x: auto;
            overflow-y: hidden;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none; /* Firefox */
            -ms-overflow-style: none; /* IE and Edge */
          }

          .mobile-categories-scroll-container::-webkit-scrollbar {
            display: none; /* Chrome, Safari, Opera */
          }

          .mobile-categories-content {
            display: flex;
            flex-direction: column;
            gap: 12px;
            width: fit-content;
            min-width: 100%;
          }

          .mobile-categories-row {
            display: flex;
            flex-wrap: nowrap;
            gap: 12px;
          }

          .mobile-category-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-decoration: none;
            color: inherit;
            flex: 0 0 auto;
            width: 80px;
          }

          .mobile-category-circle {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            background-color: #F5F5F5;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 8px;
            overflow: hidden;
            position: relative;
          }

          .mobile-category-circle img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 50%;
          }

          .mobile-category-english-label {
            display: none;
          }

          .mobile-category-arabic-label {
            font-size: 12px;
            font-weight: 500;
            color: #0e5aa7 !important;
            text-align: center;
            margin-top: 4px;
            line-height: 1.2;
          }

          /* See All item styling */
          .mobile-see-all-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-decoration: none;
            color: inherit;
          }

          .mobile-see-all-circle {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            background-color: #fff;
            border: 1px solid #E0E0E0;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 8px;
          }

          .mobile-see-all-icon {
            width: 28px;
            height: 28px;
            color: #D14343;
          }

          .mobile-see-all-icon svg {
            width: 100%;
            height: 100%;
          }

          .mobile-see-all-label {
            font-size: 12px;
            font-weight: 500;
            color: #333;
            text-align: center;
            margin-top: 4px;
          }

        `}
      </style>
      <section className="mobile-categories-grid-wrapper">
        <div className="mobile-categories-grid">
          <h2 className="mobile-categories-title">Shop by category</h2>
          <div className="mobile-categories-grid-inner">
            <div className="mobile-categories-scroll-container">
              <div className="mobile-categories-content">
                {/* First row */}
                <div className="mobile-categories-row">
                  {firstRowCategories.map((category, index) => (
                    <a
                      key={index}
                      href={category.link || "/shop/collection"}
                      className="mobile-category-item"
                    >
                      <div className="mobile-category-circle">
                        <img src={category.image} alt={category.name} />
                        <span className="mobile-category-english-label">
                          {category.name?.toUpperCase() || ""}
                        </span>
                      </div>
                      <span className="mobile-category-arabic-label">
                        {category.nameAr || category.name || ""}
                      </span>
                    </a>
                  ))}
                </div>

                {/* Second row */}
                {secondRowCount > 0 && (
                  <div className="mobile-categories-row">
                    {secondRowCategories.map((category, index) => (
                      <a
                        key={index + firstRowCount}
                        href={category.link || "/shop/collection"}
                        className="mobile-category-item"
                      >
                        <div className="mobile-category-circle">
                          <img src={category.image} alt={category.name} />
                          <span className="mobile-category-english-label">
                            {category.name?.toUpperCase() || ""}
                          </span>
                        </div>
                        <span className="mobile-category-arabic-label">
                          {category.nameAr || category.name || ""}
                        </span>
                      </a>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MobileCategoriesGrid;
